import { gql } from "@apollo/client"

const CONTRACT_DETAIL_FRAG = gql`
  fragment ContractDetailFrag on ContractType {
    id
    resourceAmount
    startDate
    endDate
    status
    contractCode
    dailyAllowance
    contractType {
      id
      name
      codename
    }
    contractrecurringexpenseSet {
      id
      shift {
        id
        name
      }
      cost
      unitCount
    }
  }
`
export const CONTRACT_DETAILS = gql`
  query ContractDetails($id: ID!) {
    contractDetails(contractId: $id) {
      ...ContractDetailFrag
    }
  }
  ${CONTRACT_DETAIL_FRAG}
`
export const ADD_UPDATE_VEHICLE_CONTRACT = gql`
  mutation AddUpdateVehicleContract(
    $id: ID
    $status: String!
    $startDate: Date!
    $endDate: Date!
    # Vehicle ID (entityIssued)
    $entityIssued: ID!
    $contractTypeId: ID!
    $resourceAmount: Int
    $dailyAllowance: Float
    $recurringExpenses: [ContractRecurringExpenseInput]
  ) {
    addUpdateVehicleContract(
      id: $id
      status: $status
      startDate: $startDate
      endDate: $endDate
      # Vehicle ID (entityIssued)
      entityIssued: $entityIssued
      contractTypeId: $contractTypeId
      resourceAmount: $resourceAmount
      dailyAllowance: $dailyAllowance
      recurringExpenses: $recurringExpenses
    ) {
      contract {
        ...ContractDetailFrag
      }
    }
  }
  ${CONTRACT_DETAIL_FRAG}
`
